import * as S from "sanctuary";

const transformer = (func) => (key) => ({
  key,
  func,
});

// toEitherEnum :: Maybe string -> Maybe Either string
export const toEitherEnum = (enumType) =>
  transformer(S.map(S.ifElse(S.is(enumType))(S.Right)(S.Left)));

export const toDollarAmount = transformer(
  S.map((amount) =>
    parseFloat(amount)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
  )
);

export const toDate = transformer(S.chain(S.parseDate));
